export default __webpack_public_path__ + "static/media/icon.3179bd45.svg";